module.exports = __webpack_public_path__ + "img/3_41.d7e46af9.png";